const CART_ITEM_TYPES = {
  DOWNLOAD: 'download',
  PRINT: 'print',
};

export { CART_ITEM_TYPES };
